import { useTransformLifeAreaSectionToGoalMutation } from 'shared/hooks/queries/use-transform-life-area-section-to-goal-mutation';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export const useTransformLifeAreaSectionToGoal = () => {
  const { mutateAsync } = useTransformLifeAreaSectionToGoalMutation();
  return (sectionId: ID, lifeArea: LifeArea) =>
    mutateAsync({ lifeArea, sectionId });
};
